
import { platformApiFetch } from '@/services/platformApi/client';
import { CategoryResult } from "@/types/supabase";

export async function getCategories(): Promise<CategoryResult[]> {
  return platformApiFetch<CategoryResult[]>('/v1/categories');
}

export async function getCategoryById(id: string): Promise<CategoryResult | null> {
  try {
    const categories = await getCategories();
    return categories.find((category) => category.id === id) || null;
  } catch (error) {
    console.error("Error fetching category:", error);
    return null;
  }
}

export async function getPopularCategories(limit: number = 6): Promise<CategoryResult[]> {
  try {
    return platformApiFetch<CategoryResult[]>(`/v1/categories/popular?limit=${limit}`);
  } catch (error) {
    console.error("Error in getPopularCategories:", error);
    return [];
  }
}

export async function createCategory(category: { name: string; icon?: string }): Promise<CategoryResult | null> {
  return platformApiFetch<CategoryResult | null>('/v1/categories', {
    method: 'POST',
    body: JSON.stringify(category),
  });
}

export async function updateCategory(id: string, category: { name?: string; icon?: string }): Promise<CategoryResult | null> {
  return platformApiFetch<CategoryResult | null>(`/v1/categories/${id}`, {
    method: 'PUT',
    body: JSON.stringify(category),
  });
}

export async function deleteCategory(id: string): Promise<boolean> {
  return platformApiFetch<boolean>(`/v1/categories/${id}`, { method: 'DELETE' });
}

export async function getCategoryNames(): Promise<string[]> {
  const categories = await getCategories();
  return categories.map(category => category.name);
}

export const getCategoriesList = getCategories;
